export const reportIssueLink = 'https://solutionsnow.one.ofc.loc/plugins/servlet/desk/portal/4/create/3125';

export const submitEnhancementLink = 'https://solutionsnow.one.ofc.loc/plugins/servlet/desk/portal/4/create/3124';

export const userGuideLink = 'https://ab-inbev.acadia.sysalli.com/browse/ZATS-500350/en-us';
